import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AdminSideNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const menuItems = [
    { icon: '📊', label: 'Dashboard', path: '/admin/dashboard' },
    { icon: '🛏️', label: 'Rooms', path: '/admin/rooms' },
    { icon: '👥', label: 'Guests', path: '/admin/guests' },
    { icon: '💰', label: 'Billing', path: '/admin/billing' },
    { icon: '📈', label: 'Reports', path: '/admin/reports' },
  ];

  const isActive = (path) => location.pathname === path;

  const styles = {
    sidebar: {
      width: collapsed ? '80px' : '260px',
      height: '100vh',
      background: 'linear-gradient(180deg, #1e3a70 0%, #2c5aa0 100%)',
      color: 'white',
      position: 'fixed',
      left: 0,
      top: 0,
      transition: 'width 0.3s ease',
      zIndex: 1000,
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '2px 0 10px rgba(0, 0, 0, 0.1)',
    },
    header: {
      padding: '1.5rem',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
    },
    logo: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.8rem',
      overflow: 'hidden',
    },
    logoIcon: {
      fontSize: '2rem',
      flexShrink: 0,
    },
    logoText: {
      fontSize: '1.5rem',
      fontWeight: 700,
      whiteSpace: 'nowrap',
      opacity: collapsed ? 0 : 1,
      transition: 'opacity 0.3s ease',
    },
    toggleBtn: {
      background: 'rgba(255, 255, 255, 0.1)',
      border: 'none',
      color: 'white',
      width: '32px',
      height: '32px',
      borderRadius: '6px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.2rem',
      transition: 'all 0.3s ease',
      flexShrink: 0,
    },
    nav: {
      flex: 1,
      padding: '1rem 0',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      padding: '1rem 1.5rem',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      textDecoration: 'none',
      color: 'white',
      border: 'none',
      background: 'transparent',
      width: '100%',
      textAlign: 'left',
      position: 'relative',
      overflow: 'hidden',
    },
    menuItemActive: {
      background: 'rgba(255, 255, 255, 0.15)',
      borderLeft: '4px solid #ff6b6b',
    },
    menuIcon: {
      fontSize: '1.5rem',
      flexShrink: 0,
    },
    menuLabel: {
      fontSize: '1rem',
      fontWeight: 500,
      whiteSpace: 'nowrap',
      opacity: collapsed ? 0 : 1,
      transition: 'opacity 0.3s ease',
    },
    footer: {
      padding: '1.5rem',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    },
    footerText: {
      fontSize: '0.75rem',
      opacity: 0.7,
      textAlign: 'center',
      whiteSpace: collapsed ? 'normal' : 'nowrap',
    },
  };

  return (
    <aside style={styles.sidebar}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.logo}>
          <span style={styles.logoIcon}>🏨</span>
          {!collapsed && <span style={styles.logoText}>HotelPro</span>}
        </div>
        <button
          style={styles.toggleBtn}
          onClick={() => setCollapsed(!collapsed)}
          onMouseOver={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
          }}
        >
          {collapsed ? '→' : '←'}
        </button>
      </div>

      {/* Navigation Menu */}
      <nav style={styles.nav}>
        {menuItems.map((item, index) => (
          <button
            key={index}
            style={{
              ...styles.menuItem,
              ...(isActive(item.path) ? styles.menuItemActive : {}),
            }}
            onClick={() => navigate(item.path)}
            onMouseOver={(e) => {
              if (!isActive(item.path)) {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                e.currentTarget.style.paddingLeft = '2rem';
              }
            }}
            onMouseOut={(e) => {
              if (!isActive(item.path)) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.paddingLeft = '1.5rem';
              }
            }}
            title={collapsed ? item.label : ''}
          >
            <span style={styles.menuIcon}>{item.icon}</span>
            {!collapsed && <span style={styles.menuLabel}>{item.label}</span>}
          </button>
        ))}
      </nav>

      {/* Footer */}
      <div style={styles.footer}>
        <p style={styles.footerText}>
          {collapsed ? '© 2024' : '© 2024 HotelPro'}
        </p>
      </div>
    </aside>
  );
};

export default AdminSideNav;